(() => {
  const billingCountrySelector = '#quick-quote-wrapper #customAddressCountryField_8936';

  function setBillingCountryToCanada() {
    const select = document.querySelector(billingCountrySelector);
    if (!select || select.value === 'CA') {
      return Boolean(select);
    }

    select.value = 'CA';
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));

    if (window.angular) {
      const scope = window.angular.element(select).scope();
      if (scope?.field) {
        scope.$applyAsync(() => {
          scope.field.Country = 'CA';
        });
      }
    }

    return true;
  }

  function initRequestQuoteDefaults() {
    if (setBillingCountryToCanada()) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (setBillingCountryToCanada()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(() => observer.disconnect(), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRequestQuoteDefaults, { once: true });
  } else {
    initRequestQuoteDefaults();
  }
})();
